module.exports = __webpack_public_path__ + "img/play.02668fee.svg";